import {
  Box,
  DefaultIcon,
  Flex,
  MoreVerticalIcon,
  Typography,
} from '@iheartjane/reefer';

import { FeatureIntroModal } from '../featureIntroModal/featureIntroModal';
import { useFeatureIntro } from '../featureIntroModal/useFeatureIntro';
import { MAX_COMPARE } from './compareProvider';

import styles from './compareIntro.module.css';

export const COMPARE_INTRO_SEEN_KEY = 'jane:compare-intro-seen';

const CardIllustration = () => (
  <Flex
    background="grays-white"
    borderRadius="sm"
    flexDirection="column"
    gap={8}
    width={140}
  >
    <Flex alignItems="center" justifyContent="center" height={140}>
      <DefaultIcon color="grays-light" size="xl" />
    </Flex>
    <Flex alignItems="center" className={styles['details']} gap={8} p={12}>
      <Flex flexDirection="column" gap={8} grow>
        <Box
          background="transparent-black-fifty"
          borderRadius="xl"
          height={15}
          width="85%"
        />
        <Box background="grays-ultralight" borderRadius="xl" height={15} />
      </Flex>
      <Flex
        alignItems="center"
        justifyContent="center"
        border="primary"
        borderWidth="3px"
        height={36}
        width={36}
        borderRadius="lg"
        mb={12}
        mr={-4}
      >
        <MoreVerticalIcon size="sm" />
      </Flex>
    </Flex>
  </Flex>
);

interface CompareIntroProps {
  /** Keep false while another overlay, such as the age gate, is up. */
  enabled: boolean;
  isMobile: boolean;
}

export const CompareIntro = ({ enabled, isMobile }: CompareIntroProps) => {
  const { close, isOpen } = useFeatureIntro({
    enabled,
    storageKey: COMPARE_INTRO_SEEN_KEY,
  });

  return (
    <FeatureIntroModal
      actionLabel="Start comparing"
      isMobile={isMobile}
      onAction={() => undefined}
      onRequestClose={close}
      open={isOpen}
      testId="compare-intro"
      title="Introducing compare!"
    >
      <CardIllustration />
      <Typography mt={16} maxWidth={300}>
        Tap the menu icon on any product card to compare up to {MAX_COMPARE}{' '}
        side by side.
      </Typography>
    </FeatureIntroModal>
  );
};
